export default __webpack_public_path__ + "static/mscs+-14533990173e2e63bc590979ff6a6b15.jpg";